<template>
  <v-container
    id="kpi-detail"
    fluid
    tag="section"
    v-if="!loading"
  >
    <v-card
      class="mx-auto my-0"
      outlined
    >
      <v-card-text>
        <v-row class="align-center">
          <v-col
            cols="12"
            md="7"
          >
            <div class="display-2 font-weight-medium">
              {{ kpi.name }}
            </div>
          </v-col>
          <v-col
            cols="12"
            md="5"
            class="text-right display-1"
          >
            <span>Ngày bắt đầu: {{ formatDate(kpi.startAt) }} |   Ngày kết thúc: {{ formatDate(kpi.endAt) }}</span>
            <v-btn
              class="primary mx-0 ml-5"
              small
              @click="exportExcel"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card outlined class="my-0" style="border-top: 0">
      <v-card-text>
        <v-tabs
          v-model="activeTab"
          color="primary"
        >
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
            :value="i"
          >
            {{ tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item
            class="mt-8"
            :value="0"
          >
            <kpi-user-table
              :users="telesales"
              :oldUsers="oldTelesales"
              :active-tab="activeTab"
              :passed="passed"
            />
          </v-tab-item>
          <v-tab-item
            class="mt-8"
            :value="1"
          >
            <kpi-user-table
              :users="managers"
              :oldUsers="oldManagers"
              :active-tab="activeTab"
              :passed="passed"
            />
          </v-tab-item>
          <v-tab-item
            class="mt-8"
            :value="2"
          >
            <kpi-department-table
              :departments="departments"
              :oldDepartments="oldDepartments"
              :active-tab="activeTab"
              :passed="passed"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  import * as moment from 'moment'
  import XLSX from 'xlsx'
  import KpiUserTable from './components/KpiUserTable.vue'
  import KpiDepartmentTable from './components/KpiDepartmentTable.vue'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    components: { KpiUserTable, KpiDepartmentTable },
    data () {
      return {
        tab: 0,
        tabs: [
          'Nhân viên TLS',
          'Trưởng nhóm TLS',
          'Nhóm TLS',
        ],
        telesales: [],
        oldTelesales: [],
        managers: [],
        oldManagers: [],
        departments: [],
        oldDepartments: [],
        kpi: {},
        kpiId: null,
        activeTab: 0,
        loading: true,
        passed: false,
        today: moment(moment()).format('YYYY-MM-DD 00:00:00'),
      }
    },
    mounted () {
      const activeTab = this.$route.query.activeTab || 0
      this.activeTab = parseInt(activeTab, 10)
  
    },
    created () {
      this.kpiId = this.$route.params.id
      this.getData()
      
    },
    methods: {
      async getData () {
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        await Promise.all([this.getTelesaleList(), this.getManagerList()])
        await this.getKpiDetail()
        // loader.hide()
        this.appLoadingData(false)
      },
      async getTelesaleList () {
        if (this.kpiId) {
          const response = await KpiRepository.getUserList(this.kpiId, { position: 'telesales', status: 'active' })
          if (_.get(response, 'success', false)) {
            this.telesales = _.get(response, 'data', [])
          }
        }
      },
      async getManagerList () {
        if (this.kpiId) {
          const response = await KpiRepository.getUserList(this.kpiId, { position: 'sale_leader', status: 'active' })
          if (_.get(response, 'success', false)) {
            this.managers = _.get(response, 'data', [])
          }
        }
      },
      async getKpiDetail () {
        if (this.kpiId) {
          const response = await KpiRepository.detail(this.kpiId)
          if (_.get(response, 'success', false)) {
            this.kpi = _.get(response, 'data', {})
            const { details = [], departments = [] } = this.kpi
            departments.forEach(department => {
              const foundDetail = details.find(d => _.get(d, 'department.id', null) === department.id && _.get(d, 'isGroup', false) === true)
              if (foundDetail) {
                department.targetRevenue = foundDetail.targetRevenue
                department.importantLevel = foundDetail.importantLevel
                department.targetRate = foundDetail.targetRate
                department.importantRateLevel = foundDetail.importantRateLevel
                department.noNeedSetKPI = foundDetail.noNeedSetKPI || false
                department.note = foundDetail.note
                department.turnOverSuccess = foundDetail.turnOverSuccess
                department.latchRatioSuccess = foundDetail.latchRatioSuccess
                department.kpi = foundDetail.kpi
              }
            })
            this.departments = departments
            this.oldDepartments = _.cloneDeep(departments)
            this.departments = departments.map(d => {
              return {
                ...d,
                totalMember: _.get(d, 'users', []).length,
              }
            })
            this.oldDepartments = _.cloneDeep(this.departments)
            const telesales = _.cloneDeep(this.telesales)
            telesales.forEach(user => {
              const foundDetail = details.find(d => _.get(d, 'user.id', null) === user.id)
              if (foundDetail) {
                user.targetRevenue = foundDetail.targetRevenue
                user.importantLevel = foundDetail.importantLevel
                user.targetRate = foundDetail.targetRate
                user.importantRateLevel = foundDetail.importantRateLevel
                user.noNeedSetKPI = foundDetail.noNeedSetKPI || false
                user.note = foundDetail.note
                user.turnOverSuccess = foundDetail.turnOverSuccess
                user.latchRatioSuccess = foundDetail.latchRatioSuccess
                user.kpi = foundDetail.kpi
              }
            })
            const managers = _.cloneDeep(this.managers)
            managers.forEach(user => {
              const foundDetail = details.find(d => _.get(d, 'user.id', null) === user.id)
              if (foundDetail) {
                user.targetRevenue = foundDetail.targetRevenue
                user.importantLevel = foundDetail.importantLevel
                user.targetRate = foundDetail.targetRate
                user.importantRateLevel = foundDetail.importantRateLevel
                user.noNeedSetKPI = foundDetail.noNeedSetKPI || false
                user.note = foundDetail.note
                user.turnOverSuccess = foundDetail.turnOverSuccess
                user.latchRatioSuccess = foundDetail.latchRatioSuccess
                user.kpi = foundDetail.kpi
              }
            })
            
            this.oldManagers = _.cloneDeep(managers)
            this.oldTelesales = _.cloneDeep(telesales)
            this.$set(this, 'managers', managers)
            this.$set(this, 'telesales', telesales)

            this.passed = moment(this.today).isAfter(moment(this.kpi.endAt).format('YYYY-MM-DD 23:59:59'))
          }
          this.loading = false
        }
      },
      exportExcel () {
        // sheet telesales
        const header = [
          'Tên nhân viên', 'Nhóm', 'Chỉ tiêu doanh thu', 'Doanh thu thực tế', 'Độ quan trọng DT (%)',
          'Chỉ tiêu tỉ lệ chốt (%)', 'Tỷ lệ chốt thực tế (%)', 'Độ quan trọng TLC (%)', 'KPI (%)', 'Ghi chú',
        ]
        const nameKPI = ['', '', '', '', 'hello']
        const telesales = this.oldTelesales.map((user) => {
          return [
            _.get(user, 'fullName', ''),
            _.get(user, 'department.name', ''),
            _.get(user, 'targetRevenue', ''),
            '',
            _.get(user, 'importantLevel', ''),
            _.get(user, 'targetRate', ''),
            '',
            _.get(user, 'importantRateLevel', ''),
            '',
            _.get(user, 'note', ''),
          ]
        })
        telesales.unshift(header)
        telesales.unshift(nameKPI)
        const wsTelesales = XLSX.utils.aoa_to_sheet(telesales);

        // sheet manager
        const managers = this.oldManagers.map((user) => {
          return [
            _.get(user, 'fullName', ''),
            _.get(user, 'department.name', ''),
            _.get(user, 'targetRevenue', ''),
            '',
            _.get(user, 'importantLevel', ''),
            _.get(user, 'targetRate', ''),
            '',
            _.get(user, 'importantRateLevel', ''),
            '',
            _.get(user, 'note', ''),
          ]
        })
        managers.unshift(header)
        managers.unshift(nameKPI)
        const wsManager = XLSX.utils.aoa_to_sheet(managers);

        // sheet deparment
        const departmentHeader = [
          'Nhóm', 'Số nhân viên', 'Chỉ tiêu doanh thu', 'Doanh thu thực tế', 'Độ quan trọng DT (%)',
          'Chỉ tiêu tỉ lệ chốt (%)', 'Tỷ lệ chốt thực tế (%)', 'Độ quan trọng TLC (%)', 'KPI (%)', 'Ghi chú',
        ]
        const departments = this.oldDepartments.map((department) => {
          return [
            _.get(department, 'name', ''),
            _.get(department, 'totalMember', ''),
            _.get(department, 'targetRevenue', ''),
            '',
            _.get(department, 'importantLevel', ''),
            _.get(department, 'targetRate', ''),
            '',
            _.get(department, 'importantRateLevel', ''),
            '',
            _.get(department, 'note', ''),
          ]
        })
        departments.unshift(departmentHeader)
        departments.unshift(nameKPI)
        const wsDepartment = XLSX.utils.aoa_to_sheet(departments);

        // export file
        const newWorkbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(newWorkbook, wsTelesales, "Nhân viên TLS");
        XLSX.utils.book_append_sheet(newWorkbook, wsManager, "Trưởng nhóm TLS");
        XLSX.utils.book_append_sheet(newWorkbook, wsDepartment, "Nhóm TLS");
        XLSX.writeFile(newWorkbook, 'kpi.xlsx');
      }
    },
  }
</script>
<style lang="sass" scope>
.table-custom
  thead
    background-color: rgba(0, 0, 0, .1)
    tr
      &:last-child
        th
          padding: 8px
          border-bottom: thin solid rgba(0, 0, 0, .1) !important
      th
        border-bottom: thin solid rgba(0, 0, 0, .1)
</style>
